module.exports = __webpack_public_path__ + "img/account_mb_04.0ac77416.png";